// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_TWO_FACTOR_AUTH_SECRET = 'auth/SET_TWO_FACTOR_AUTH_SECRET';
export const UNSET_TWO_FACTOR_AUTH_SECRET = 'auth/UNSET_TWO_FACTOR_AUTH_SECRET';
export const SET_TWO_FACTOR_AUTH_RECOVERY_CODES = 'auth/SET_TWO_FACTOR_AUTH_RECOVERY_CODES';
export const UNSET_TWO_FACTOR_AUTH_RECOVERY_CODES = 'auth/UNSET_TWO_FACTOR_AUTH_RECOVERY_CODES';
export const SET_SHOULD_GENERATE_TWO_FACTOR_AUTH_RECOVERY_CODES = 'auth/SET_SHOULD_GENERATE_TWO_FACTOR_AUTH_RECOVERY_CODES';